import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "user-info"
}
const _hoisted_5 = { class: "el-dropdown-link" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "item-left" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "item-left" }
const _hoisted_10 = ["src"]

import { ref, onMounted, watch, version } from "vue";
import { useRouter } from "vue-router";
import { versions } from "@/utils/utils";
import routerTree from "@/router/config";
import userInfoStore from "@/store/index";
import headImg from "@/assets/head_img.png";
import logo from "@/assets/logo.png";
import userIcon from "@/assets/user_icon.png";
import logOut from "@/assets/log_out.png";
import api from "@/services/index";

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const router = useRouter();
const userStore = userInfoStore();
const tipOpen = ref(false);
console.log("userStore", userStore.isLogin, userStore.userInfo);
//返回主页
const backHome = () => {
  window.location.href = "https://www.stdaily.com";
};
//跳转个人中心
const toPersonCenter = () => {
  router.push(routerTree.personCenter.main); // 跳转到个人中心
};
//登录
const loginHandle = () => {
  router.push(routerTree.login); // 跳转到登录
};
//退出登录
const logOutHandle = () => {
  localStorage.removeItem("token");
  userStore.isLogin = false;
  userStore.userInfo = {};
  router.push(routerTree.login);
};

//获取用户个人信息
const getUserInfo = async () => {
  try {
    const res = await api.login.getUserInfo({});
    if (res.status == 200) {
      localStorage.setItem("userInfo", JSON.stringify(res.obj));
      userStore.isLogin = true;
      userStore.userInfo = res.obj;
    }
  } catch (err) {
    console.log("err", err);
  }
};

onMounted(() => {
  console.log("version1", versions());
  // if (versions().isIOS || versions().isAndroid || versions().isHarmony) {
  //   tipOpen.value = true;
  // }
  const token = localStorage.getItem("token");
  if (token) {
    getUserInfo();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_arrow_down = _resolveComponent("arrow-down")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_ArrowRightBold = _resolveComponent("ArrowRightBold")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        class: "logo-info",
        src: _unref(logo),
        onClick: backHome
      }, null, 8, _hoisted_2),
      (!_unref(userStore)?.isLogin)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "user-info",
            onClick: loginHandle
          }, [
            _createElementVNode("img", { src: _unref(headImg) }, null, 8, _hoisted_3),
            _cache[0] || (_cache[0] = _createElementVNode("span", null, "登录", -1))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_el_dropdown, {
              trigger: "click",
              size: "large"
            }, {
              dropdown: _withCtx(() => [
                _createVNode(_component_el_dropdown_menu, { class: "custom-dropdown" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_dropdown_item, {
                      class: "custom-item",
                      onClick: toPersonCenter
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("img", { src: _unref(userIcon) }, null, 8, _hoisted_8),
                          _cache[1] || (_cache[1] = _createElementVNode("span", null, "个人中心", -1))
                        ]),
                        _createVNode(_component_el_icon, {
                          color: "#999999",
                          size: "1.4rem"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ArrowRightBold)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_dropdown_item, {
                      class: "custom-item",
                      onClick: logOutHandle
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("img", { src: _unref(logOut) }, null, 8, _hoisted_10),
                          _cache[2] || (_cache[2] = _createElementVNode("span", null, "退出登录", -1))
                        ]),
                        _createVNode(_component_el_icon, {
                          color: "#999999",
                          size: "1.4rem"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ArrowRightBold)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_5, [
                  _createElementVNode("img", {
                    src: _unref(userStore)?.userInfo.avatar || _unref(headImg)
                  }, null, 8, _hoisted_6),
                  _createElementVNode("span", null, _toDisplayString(_unref(userStore)?.userInfo.nickname), 1),
                  _createVNode(_component_el_icon, {
                    class: "el-icon--right",
                    color: "#0D59FA",
                    size: "1.4rem"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_arrow_down)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]))
    ]),
    _createVNode(_component_router_view)
  ], 64))
}
}

})